import { Card } from 'baseui/card';
import { StyledDivider } from 'baseui/divider';
import { CSSProperties, memo } from 'react';
import { ListChildComponentProps } from 'react-window';
import { useRecoilValue } from 'recoil';
import { journeyState } from '../../storage/journeys';
import JourneyCardBody from './JourneyCardBody';
import JourneyCardHeader from './JourneyCardHeader';

function JourneyCard({ data, index, style }: ListChildComponentProps) {
  const id = data[index];
  const journey = useRecoilValue(journeyState(id));

  if (!journey) {
    return null;
  }

  return (
    <span style={style as CSSProperties}>
      <Card
        overrides={{
          Root: {
            style: {
              height: 'calc(100% - 16px)',
              boxSizing: 'border-box',
              borderLeftWidth: '1px',
              borderRightWidth: '1px',
              borderTopWidth: '1px',
              borderBottomWidth: '1px',
            },
          },
          Contents: {
            style: {
              marginTop: 0,
              marginRight: 0,
              marginBottom: 0,
              marginLeft: 0,
            },
          },
          Body: {
            style: {
              marginBottom: 0,
            },
          },
        }}
      >
        <JourneyCardHeader journey={journey} />
        <StyledDivider
          $size="cell"
          style={{ marginTop: 0, marginBottom: 0 }}
        />
        <JourneyCardBody journey={journey} />
      </Card>
    </span>
  );
}

export default memo(JourneyCard);
